var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VMSSelect',{attrs:{"id":_vm.id,"items":_vm.Items,"label":_vm.label,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"multiple":_vm.multiple,"chips":_vm.multiple,"rules":_vm.rules},model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}})
}
var staticRenderFns = []

export { render, staticRenderFns }